import { IWebConfig, IWebServicesConfig } from 'config/interfaces'
import { CityOfAbcWebConfig } from 'config/NCPERS/CityOfAbc'
import * as _ from 'lodash'

const productionServer = 'http://local705.themajordomo.com/'
const testServer = 'http://tjdhome.ddns.net:8001/retirementAppServer/'

const WebServices: IWebServicesConfig = {
  accountsEndpoint: productionServer,
  familyInfoEndpoint: productionServer,
  ssaWorkbookEndpoint: productionServer,
  ncpersWorkbookEndpoint: productionServer,
  testWorkbookEndpoint: productionServer,
  miscEndpoint: productionServer,
  workbookEndpoint: productionServer
}

const ServerDevConfig: IWebConfig = _.defaults({}, { WebServices }, CityOfAbcWebConfig)

export {
  ServerDevConfig
}



// WEBPACK FOOTER //
// ./src/config/dev/ServerDev.ts